<template>
  <b-modal v-model="isActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title title-success">Bulk Export</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Please select a field">
          <b-select expanded v-model="form['field']" @input="checkType">
            <option
              required
              v-for="(option, index) in columnsConfig"
              :value="option.product_data_column.trim()"
              :key="index"
            >
              {{ option.field_name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="" v-if="input">
          <b-input required v-model="form['value']" maxlength="255"> </b-input>
        </b-field>
        <b-field label="" v-if="date">
          <b-datepicker
            v-model="form['value']"
            icon="calendar-today"
            trap-focus
            class="cdf-edit-add-padding cdf-edit-date-picker"
            required
          ></b-datepicker>
        </b-field>
        <b-field label="" v-if="dropDown">
          <b-select
            v-if="!dropDownGroup"
            class="cdf-edit-add-padding cdf-edit-select"
            @input="getDependantFieldValue"
            v-model="form['value']"
          >
            <option
              v-for="(value, index) in columnsConfig[index][
                'dropdown_field_values'
              ]"
              :value="value"
              :key="index"
            >
              {{ value }}
            </option>
          </b-select>

          <b-select
            class="cdf-edit-add-padding cdf-edit-select"
            v-model="form['value']"
            v-if="dropDownGroup"
          >
            <optgroup
              v-for="(value, name, index) in columnsConfig[index][
                'dropdown_field_values'
              ][0]"
              :key="index"
              :label="name"
            >
              <option v-for="(v, k) in value" :value="v" :key="k">{{
                v
              }}</option></optgroup
            >
          </b-select>
        </b-field>

        <b-field
          :label="removeAdditionalChars(this.dependentField, '_')"
          v-if="isDependentField"
        >
          <b-select
            class="cdf-edit-add-padding cdf-edit-select"
            v-model="form['dependentFieldValue']"
            v-if="subCategoryList.length > 0"
          >
            <option
              v-for="(value, index) in subCategoryList"
              :value="value"
              :key="index"
            >
              {{ value }}
            </option>
          </b-select>
          <b-select
            class="cdf-edit-add-padding cdf-edit-select"
            v-model="form['dependentFieldValue']"
            v-else-if="isSubcategory"
          >
            <optgroup
              v-for="(value, name, index) in columnsConfig[dependentIndex][
                'dropdown_field_values'
              ][0]"
              :key="index"
              :label="name"
            >
              <option v-for="(v, k) in value" :value="v" :key="k">{{
                v
              }}</option></optgroup
            >
          </b-select>
          <b-select
            class="cdf-edit-add-padding cdf-edit-select"
            v-model="form['dependentFieldValue']"
            v-else
          >
            <option
              v-for="(value, index) in columnsConfig[dependentIndex][
                'dropdown_field_values'
              ]"
              :value="value"
              :key="index"
            >
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Cancel" class="is-normal" @click="cancel" />
        <b-button slot="right" type="is-primary" @click="confirm">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import DataManagementService from "../../services/DataManagementImportService";
import ErrorMixin from "@/mixins/ErrorMixin";
import ProductMixin from "@/mixins/ProductMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
export default {
  name: "BulkProductEdit",
  mixins: [ErrorMixin, ProductMixin, UtilityMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },

    customerId: {
      type: Number,
      default: -1
    },

    columns: {
      type: Array
    },
    columnsConfig: {
      type: Array
    },

    checkedRows: {
      type: Array
    },

    isCheckedAllRows: {
      type: Boolean
    },
    stream: {
      type: String
    },
    tempProduct: {
      type: Boolean
    },
    query: {
      type: String
    }
  },

  data() {
    return {
      isDependentField: false,
      isModalActive: false,
      selectDisable: true,
      dropDown: false,
      dropDownGroup: false,
      input: false,
      date: false,
      index: 0,
      dependentIndex: 0,
      dependentField: null,
      isSubcategory: false,
      subCategoryList: [],
      form: {},
      DataManagementService: new DataManagementService()
    };
  },
  methods: {
    checkType(val) {
      this.form["value"] = "";
      this.form["dependentFieldValue"] = "";
      this.subCategoryList.length = 0;
      const index = this.find_column_config_index(val);
      this.index = index;
      this.isDependentField = false;
      this.dependentField = null;

      if (this.index >= 0) {
        // check the field type and set the html field based on the type
        if (this.columnsConfig[index]["field_type"] == "Dropdown") {
          this.dropDown = true;
          // check for product sub category
          // e.g product family
          if (
            typeof this.columnsConfig[index]["dropdown_field_values"][0] ===
            "object"
          ) {
            this.dropDownGroup = true;
          } else {
            this.dropDownGroup = false;
          }
          this.input = this.date = false;
        } else if (
          this.columnsConfig[index]["field_type"] == "Text" ||
          this.columnsConfig[index]["field_type"] == "Number"
        ) {
          this.dropDown = this.date = false;
          this.input = true;
        } else if (this.columnsConfig[index]["field_type"] == "Date") {
          this.input = this.dropDown = false;
          this.date = true;
        }

        // check if the field is dependent on other field
        const dependent_field = this.columnsConfig[index][
          "dependent_data_column"
        ];

        if (dependent_field) {
          this.dependentIndex = this.columnsConfig.findIndex(
            col => col.product_data_column.trim() == dependent_field
          );
          // check for product sub category
          // e.g product family
          if (
            typeof this.columnsConfig[this.dependentIndex][
              "dropdown_field_values"
            ][0] === "object"
          ) {
            this.isSubcategory = true;
          } else {
            this.isSubcategory = false;
          }

          this.isDependentField = true;
          this.dependentField = dependent_field;
        }
      }
    },
    cancel() {
      this.form = {};
      this.input = this.date = this.dropDown = this.isDependentField = false;
      this.$emit("cancel");
    },
    confirm() {
      if (!this.form["field"]) {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "please choose the field you want to update.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return false;
      }
      if (!this.form["value"]) {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "please input the value for the selected field.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });

        return false;
      }
      // check for dependent input value
      if (this.isDependentField && !this.form["dependentFieldValue"]) {
        this.$buefy.dialog.alert({
          title: "Warning",
          message:
            "please input the value for " +
            this.columnsConfig[this.dependentIndex]["field_name"],
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });

        return false;
      }

      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure?",
        cancelText: "No",
        confirmText: "Yes",
        onConfirm: () => this.updateData()
      });
    },

    updateData() {
      const checkedData = this.isCheckedAllRows
        ? this.isCheckedAllRows
        : this.checkedRows;
      let workflow_id = null;
      if (this.tempProduct) workflow_id = this.$route.params.id;

      this.DataManagementService.bulkProductEdit(
        workflow_id,
        this.customerId,
        this.tempProduct,
        this.form,
        this.dependentField,
        this.stream,
        checkedData,
        this.query
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.$emit("reload");
        this.isModalActive = false;
      }, this.handleApiError);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
